export class UTMParameters {
	utmSource: string;
	utmMedium: string;
	utmTerm: string;
	utmContent: string;
	utmCampaign: string;
}
